<template>
  <div id="app">
    <Header />
    <Info />
    <List :list="list" type="imgText" @onClickList="onClickList" />
    <List :list="listOnlyText" title="기타메뉴" type="text" />
    <Icon />
    <Footer />
    <Popup @onClickBtn="onClickBtn" :isClick="isClick" :value="value" />

    <div class="icon54">
      아이콘 제작자
      <a href="https://icon54.com/" title="Pixel perfect">Pixel perfect</a>
      from
      <a href="https://www.flaticon.com/kr/" title="Flaticon"
        >www.flaticon.com</a
      >
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import List from "./components/List.vue";
import Popup from "./components/Popup.vue";
import Info from "./components/Info.vue";
import Icon from "./components/Icon.vue";

export default {
  name: "App",
  components: {
    List,
    Popup,
    Info,
    Icon,
    Header,
    Footer,
  },
  data() {
    return {
      list: [
        {
          img: "img1",
          title: "바람떡",
          vtn: "BA RAM TOK",
        },
        {
          img: "img2",
          title: "꿀떡",
          vtn: "KUL TOK",
        },
        {
          img: "img3",
          title: "찹쌀모찌",
          vtn: "MÔ CHI",
        },
        {
          img: "img4",
          title: "송편",
          vtn: "SÔNG PEN",
        },
        {
          img: "img5",
          title: "인절미",
          vtn: "IM JUL MI",
        },
        {
          img: "img54",
          title: "쑥 인절미",
          vtn: "SUC IM JUL MI",
        },
        {
          img: "img6",
          title: "감자떡",
          vtn: "CAM CHA TOK",
        },
        {
          img: "img7",
          title: "삼색경단",
          vtn: "KENG DAN",
        },
        {
          img: "img8",
          title: "팥경단",
          vtn: "PAT KENG ĐAN",
        },
        {
          img: "img9",
          title: "수수팥떡",
          vtn: "SUSU PAT TOK",
        },
        {
          img: "img10",
          title: "팥시루떡",
          vtn: "SI ĐÔ",
        },
        {
          img: "img11",
          title: "호박시루떡",
          vtn: "SI HÔ BAC",
        },
        {
          img: "img12",
          title: "녹두편",
          vtn: "SI XANH",
        },
        {
          img: "img55",
          title: "호박동부편",
          vtn: "HÔ BAC DONG BU PYEN",
        },
        {
          img: "img13",
          title: "흑임자 말이",
          vtn: "HU IM CHA MA RI",
        },
        {
          img: "img14",
          title: "무지개떡",
          vtn: "MAU",
        },
        {
          img: "img15",
          title: "백설기",
          vtn: "BE SOL GI",
        },
        {
          img: "img16",
          title: "꿀설기",
          vtn: "CUL SOL GI",
        },
        {
          img: "img17",
          title: "호박설기",
          vtn: "HÔ BAC SOL GI",
        },
        {
          img: "img23",
          title: "현미찰떡",
          vtn: "NEP LUC CHAL TOK",
        },
        {
          img: "img18",
          title: "쑥 찰떡",
          vtn: "SUC CHAL TOK",
        },
        {
          img: "img56",
          title: "생생아침(찰떡)",
          vtn: "SAENG SAENG MORNING CHAL TOK",
        },
        {
          img: "img59",
          title: "호박콩떡",
          vtn: "HÔ BAC KHÔNG TOK",
        },
        {
          img: "img53",
          title: "연밥동부찰떡",
          vtn: "LOTUS SEED CHAL TOK",
        },
        {
          img: "img38",
          title: "떡국",
          vtn: "TOK KUK",
        },
        {
          img: "img39",
          title: "칼라떡국",
          vtn: "Màu Sắc TOK KUK",
        },
        {
          img: "img43",
          title: "가래떡",
          vtn: "GA RE TOK",
        },
        {
          img: "img57",
          title: "현미가래떡",
          vtn: "NEP LUC GA RE TOK",
        },
        {
          img: "img44",
          title: "떡볶이",
          vtn: "TOKBOKKI",
        },
        {
          img: "img45",
          title: "치즈 떡볶이",
          vtn: "TOKBOKKI PHO MAI",
        },
        {
          img: "img46",
          title: "누들떡볶이",
          vtn: "NOODLE TOKBOKKI",
        },
        {
          img: "img24",
          title: "쑥개떡",
          vtn: "SUC KE TOK",
        },
        {
          img: "img25",
          title: "쑥 굴레",
          vtn: "SUC KU LE",
        },
        {
          img: "img26",
          title: "호박말이",
          vtn: "HÔ BAC MA RI ",
        },
        {
          img: "img27",
          title: "쑥말이",
          vtn: "SUC MA RI",
        },
        {
          img: "img19",
          title: "고구마말이",
          vtn: "MA RI",
        },
        {
          img: "img20",
          title: "앙꼬말이",
          vtn: "ANG CÔ MA RI",
        },
        {
          img: "img21",
          title: "흑미말이",
          vtn: "NEP THAN MA RI",
        },
        {
          img: "img28",
          title: "약식",
          vtn: "CƠM DEN",
        },
        {
          img: "img29",
          title: "오매기떡",
          vtn: "Ô ME GI TOK",
        },
        {
          img: "img58",
          title: "복떡",
          vtn: "BOK TOK",
        },
        {
          img: "img30",
          title: "투텁떡",
          vtn: "ĐU THOP TOK",
        },
        {
          img: "img42",
          title: "구름떡",
          vtn: "GU RUN TOK",
        },
        {
          img: "img31",
          title: "콩꿀떡",
          vtn: "KHÔNG CUL TOK",
        },
        {
          img: "img32",
          title: "특선 영양떡",
          vtn: "DAC BIET NEP LUC YONG YANG TOK",
        },
        {
          img: "img33",
          title: "찰모듬떡",
          vtn: "MÔ DUM",
        },
        {
          img: "img34",
          title: "절편",
          vtn: "JUL PYEN",
        },
        {
          img: "img22",
          title: "앙꼬절편",
          vtn: "ANG CÔ JUL PYEN",
        },
        {
          img: "img35",
          title: "술떡",
          vtn: "SUL TOK",
        },
        {
          img: "img36",
          title: "찹쌀호떡",
          vtn: "CHAP SAL HÔ TOK",
        },
        {
          img: "img37",
          title: "생일케익떡",
          vtn: "Bánh sinh nhật",
        },
        {
          img: "img40",
          title: "찐빵",
          vtn: "BANH BAO",
        },
        {
          img: "img41",
          title: "약과",
          vtn: "YA QUA",
        },
        {
          img: "img47",
          title: "모듬강정",
          vtn: "KANG CHONG",
        },
        {
          img: "img48",
          title: "찹쌀유과",
          vtn: "CHAP SAL YU QUA",
        },
        {
          img: "img49",
          title: "10곡미숫가루",
          vtn: "MI SU KA RU",
        },
        {
          img: "img50",
          title: "오뎅",
          vtn: "Chả Cá",
        },
        {
          img: "img51",
          title: "고기,김치만두",
          vtn: "Thịt MAN DU / KIM CHI MAN DU",
        },
        {
          img: "img52",
          title: "쌀/찹쌀가루",
          vtn: "BOT NEP GAO",
        },
      ],
      listOnlyText: [
        {
          title: "단호박콩설기",
        },
        {
          title: "땅콩 흑미편",
        },
        {
          title: "식혜",
        },
        {
          title: "사골육수",
        },
        {
          title: "청국장",
        },
      ],
      isClick: false,
      value: null,
    };
  },
  methods: {
    onClickList(prop) {
      this.value = prop;
      this.isClick = true;
    },
    onClickBtn(prop) {
      this.isClick = prop;
    },
  },
};
</script>

<style lang="scss">
@import url(http://fonts.googleapis.com/earlyaccess/nanumgothic.css);
@import "@/assets/utils/scss/fluid-typo.scss";

body {
  margin: 0;
  padding: 0;
}
#app {
  min-width: 350px;
  font-family: NanumGothic, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2d2a29;
}

.icon54 {
  width: 1px;
  height: 1px;
  overflow: hidden;
  position: absolute;
  left: -999999999999vw;
  top: -999999999999vh;
}
@media screen and (min-width: 1200px) {
  .sticky {
    display: none;
  }
}
</style>
